"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductInfoDialog = void 0;
var _environment = require("@ori/environment");
var _presentationHooks = require("@ori/presentation-hooks");
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _constants = require("../constants");
var _DialogContainer = require("../containers/DialogContainer");
var _shouldShowIsDiscontinuedErrorInfo = require("../utils/shouldShowIsDiscontinuedErrorInfo");
var _useGetProductBoxConfiguration = require("./useGetProductBoxConfiguration");
var _useGetProductInfoDialogProducts = require("./useGetProductInfoDialogProducts");
var _jsxRuntime = require("react/jsx-runtime");
/** Enable personal subscriptions, docs: https://dev.azure.com/oriflame/GlobalDev/_wiki/wikis/GlobalDev.wiki/11422/Personal-subscriptions */const PersonalSubscriptions = '7D673EF4-D085-44B5-BB1C-8FE57F1286BD';
const useProductInfoDialog = ({
  dialog,
  fetchMode = _constants.FETCH_MODE_LAZY,
  mode = _constants.DIALOG_MODE_STANDARD_BUY,
  productCodes,
  shared,
  analytics,
  initialProductCode,
  replaceSubscription
}) => {
  const {
    onClose: onCloseProp,
    ...dialogProps
  } = dialog ?? {};
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    data: products,
    fetch: fetchProducts,
    isLoaded: areProductsLoaded,
    isLoading: areProductsLoading
  } = (0, _useGetProductInfoDialogProducts.useGetProductInfoDialogProducts)({
    productCodes
  });
  const {
    data,
    fetch: fetchShowMrpStatement,
    isLoaded: isProductBoxConfigurationLoaded,
    isLoading: isProductBoxConfigurationLoading
  } = (0, _useGetProductBoxConfiguration.useGetProductBoxConfiguration)();
  const {
    isMrpStatementEnabled,
    isRatingsAndReviewsEnabled
  } = data;
  const {
    data: {
      isEnabled: personalSubscriptionsEnabled
    } = {
      isEnabled: false
    },
    isLoading: isFeatureToggleLoading
  } = (0, _staticApiClientReact.useGetTenantFeatureToggle)(tenant, PersonalSubscriptions, {
    swr: (0, _presentationUtils.getRetryErrorSwrOptions)()
  });
  const {
    open: isOpen,
    onClose,
    onOpen
  } = (0, _presentationHooks.useDisclose)();
  const isLoaded = isProductBoxConfigurationLoaded && areProductsLoaded;
  const isLoading = isProductBoxConfigurationLoading || areProductsLoading || isFeatureToggleLoading;
  const fetchData = (0, _react.useCallback)(() => {
    if (!isLoaded) {
      fetchProducts();
      fetchShowMrpStatement();
    }
  }, [fetchProducts, fetchShowMrpStatement, isLoaded]);
  const close = (0, _react.useCallback)(() => {
    onClose();
    onCloseProp?.();
  }, [onClose, onCloseProp]);
  const open = (0, _react.useCallback)(() => {
    onOpen();
    if (fetchMode === _constants.FETCH_MODE_LAZY) {
      fetchData();
    }
  }, [fetchData, fetchMode, onOpen]);
  (0, _react.useEffect)(() => {
    if (fetchMode === _constants.FETCH_MODE_EAGER) {
      fetchData();
    }
  }, [fetchData, fetchMode]);
  const dialogMode = (0, _react.useMemo)(() => {
    if (isLoading) {
      return _constants.DIALOG_MODE_LOADING;
    } else if (products.length === 0) {
      return _constants.NOT_FOUND;
    } else if ((0, _shouldShowIsDiscontinuedErrorInfo.shouldShowIsDiscontinuedErrorInfo)(products)) {
      return _constants.DISCONTINUED;
    }
    return mode;
  }, [isLoading, mode, products]);
  return (0, _react.useMemo)(() => ({
    closeProductInfoDialog: close,
    isProductInfoDialogOpen: isOpen,
    openProductInfoDialog: open,
    productInfoDialog: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContainer.DialogContainer, {
      analytics: analytics,
      initialProductCode: initialProductCode,
      replaceSubscription: replaceSubscription,
      dialog: {
        ...dialogProps,
        onClose: close,
        open: isOpen
      },
      mode: dialogMode,
      products: products,
      shared: {
        ...shared,
        isMrpStatementEnabled,
        isRatingsAndReviewsEnabled,
        personalSubscriptionsEnabled
      }
    })
  }), [close, isOpen, open, analytics, initialProductCode, replaceSubscription, dialogProps, dialogMode, products, shared, isMrpStatementEnabled, isRatingsAndReviewsEnabled, personalSubscriptionsEnabled]);
};
exports.useProductInfoDialog = useProductInfoDialog;
